export type ChannelKind = "channel" | "section" | "column";

export interface Channel {
  slug: string;
  name: string;
  kind: ChannelKind;
  icon: string;
  intro: string;
  count: number;
  update: string;
  hot: boolean;
}

export const channels: Channel[] = [
  {
    slug: "star",
    name: "明星八卦版块",
    kind: "section",
    icon: "ri-star-smile-line",
    intro: "聚焦艺人公开行程、活动现场与社交动态，按时间线整理成可追溯的资讯线索。",
    count: 1284,
    update: "5分钟前",
    hot: true,
  },
  {
    slug: "drama",
    name: "影视爆料频道",
    kind: "channel",
    icon: "ri-film-line",
    intro: "剧集开机、杀青、定档与幕后花絮集中地，新剧物料第一时间归档。",
    count: 962,
    update: "18分钟前",
    hot: true,
  },
  {
    slug: "variety",
    name: "综艺热点栏目",
    kind: "column",
    icon: "ri-mic-line",
    intro: "热播综艺的嘉宾阵容、录制现场与话题走向，按节目单独成栏。",
    count: 738,
    update: "32分钟前",
    hot: true,
  },
  {
    slug: "influencer",
    name: "网红追踪版块",
    kind: "section",
    icon: "ri-live-line",
    intro: "直播动态、内容创作者动向与平台热点，聚合呈现完整时间线。",
    count: 651,
    update: "1小时前",
    hot: false,
  },
  {
    slug: "music",
    name: "音乐风云频道",
    kind: "channel",
    icon: "ri-music-2-line",
    intro: "专辑发行、舞台现场与音乐节阵容，华语与海外音乐动态一栏收齐。",
    count: 540,
    update: "2小时前",
    hot: false,
  },
  {
    slug: "fashion",
    name: "时尚资源栏目",
    kind: "column",
    icon: "ri-vip-diamond-line",
    intro: "红毯造型、品牌合作与杂志封面，梳理艺人时尚资源脉络。",
    count: 476,
    update: "3小时前",
    hot: false,
  },
  {
    slug: "behind",
    name: "幕后揭秘版块",
    kind: "section",
    icon: "ri-clapperboard-line",
    intro: "剧组日常、制作团队访谈与拍摄现场还原，带你看懂台前幕后。",
    count: 388,
    update: "4小时前",
    hot: true,
  },
  {
    slug: "trending",
    name: "全网热搜频道",
    kind: "channel",
    icon: "ri-fire-line",
    intro: "聚合各平台热搜榜单变化，记录话题从升温到回落的完整过程。",
    count: 1502,
    update: "刚刚",
    hot: true,
  },
];

export interface Article {
  id: string;
  title: string;
  summary: string;
  channelSlug: string;
  channelName: string;
  author: string;
  date: string;
  readTime: string;
  cover: string;
  tags: string[];
  hot: number;
  views: number;
  content: string[];
}

export const articles: Article[] = [
  {
    id: "2026-0912-01",
    title: "年度音乐盛典后台花絮流出 舞台之外的相处细节引发热议",
    summary:
      "盛典结束后的后台通道被镜头记录，几位嘉宾互相打趣的片段被网友整理成合集，相关话题一小时内冲上热搜前列。",
    channelSlug: "music",
    channelName: "音乐风云频道",
    author: "看料社编辑部",
    date: "2026-09-12",
    readTime: "6分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20stage%20backstage%20corridor%20with%20amber%20spotlights%20and%20hanging%20costumes%2C%20artistic%20editorial%20photography%2C%20muted%20terracotta%20tones%2C%20no%20people%2C%20cinematic%20soft%20focus&width=800&height=600&seq=kl-art-01&orientation=landscape",
    tags: ["音乐盛典", "后台花絮", "热搜话题"],
    hot: 9860,
    views: 128000,
    content: [
      "本届年度音乐盛典在昨夜落幕，除了舞台上完整呈现的表演曲目，真正让话题持续升温的，反而是散场后的那段后台通道。",
      "从多位现场工作人员分享的画面可以看到，几位嘉宾在候场区域互相整理服装、对台词，还临时约定了一段没有写进节目单的合唱。这段并未在直播中出现的互动，被网友剪成合集后迅速传播。",
      "有观众注意到，其中一位歌手把备用耳返递给同台新人，这一细节被反复讨论。相关话题在一小时内进入热搜前列，评论区更多是在讨论艺人在正式舞台之外的状态。",
      "盛典主办方随后回应，表示后台区域的开放拍摄是今年新增的环节，目的是让观众看到更完整的筹备过程。截至发稿，该合集在多平台的累计播放量仍在上升。",
    ],
  },
  {
    id: "2026-0912-02",
    title: "新剧杀青现场画面曝光 主创团队深夜聚餐氛围轻松",
    summary:
      "历时四个月拍摄的都市剧正式杀青，剧组释出的现场照片里，导演与主演围坐讨论的画面被粉丝截图保存。",
    channelSlug: "drama",
    channelName: "影视爆料频道",
    author: "看料社剧集组",
    date: "2026-09-12",
    readTime: "5分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20film%20set%20wrap%20party%20table%20with%20warm%20string%20lights%20and%20paper%20cups%2C%20editorial%20photography%2C%20amber%20and%20brown%20palette%2C%20no%20people%2C%20soft%20evening%20glow&width=800&height=600&seq=kl-art-02&orientation=landscape",
    tags: ["杀青", "都市剧", "剧组幕后"],
    hot: 8120,
    views: 96000,
    content: [
      "经过四个月的连续拍摄，都市题材剧集《长夏未晚》于前日正式杀青。剧组在官方社交账号发布了九张现场照片。",
      "照片中可以看到，最后一个镜头拍摄完成后，导演与主演围坐在监视器旁复盘整场戏的处理方式。工作人员透露，这场戏因为光线原因反复调整了七次。",
      "当晚的杀青聚餐选择在片场附近的小馆进行，没有安排媒体。多位演员在个人账号发文告别角色，文字内容都提到拍摄期间的高温天气。",
      "该剧目前进入后期制作阶段，制片方表示剪辑与配乐仍需三个月左右，具体上线时间尚未公布。",
    ],
  },
  {
    id: "2026-0911-03",
    title: "综艺录制现场临时调整流程 嘉宾互动环节被保留到正片",
    summary:
      "最新一期综艺录制时，原定的竞技环节因场地原因改为即兴聊天，现场反应出奇地好，制作组决定完整保留。",
    channelSlug: "variety",
    channelName: "综艺热点栏目",
    author: "看料社综艺组",
    date: "2026-09-11",
    readTime: "4分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20empty%20chairs%20and%20warm%20amber%20lighting%2C%20editorial%20photography%2C%20terracotta%20and%20cream%20palette%2C%20no%20people%2C%20soft%20cinematic%20tone&width=800&height=600&seq=kl-art-03&orientation=landscape",
    tags: ["综艺录制", "即兴环节", "正片"],
    hot: 6430,
    views: 72000,
    content: [
      "据现场观众透露，最新一期户外综艺在录制当天遇到暴雨，原本规划的竞技环节无法在户外完成。",
      "制作组临时调整方案，把场地改到室内，并把竞技环节替换成了自由聊天。几位常驻嘉宾围坐在一起，从最近的工作聊到入行经历。",
      "意外的是，这段没有脚本的聊天产生了大量自然反应，现场笑声不断。制作人在录制结束后确认，这段内容会完整放进正片。",
      "改版后的这期节目预计在本月底播出，官方只放出了十五秒的预告，没有透露更多细节。",
    ],
  },
  {
    id: "2026-0911-04",
    title: "红毯造型盘点 高定礼服与简约西装形成两种风格路线",
    summary:
      "本届电影之夜的红毯环节依旧看点密集，造型工作室在活动后陆续放出拍摄花絮，两种搭配思路成为讨论焦点。",
    channelSlug: "fashion",
    channelName: "时尚资源栏目",
    author: "看料社时尚组",
    date: "2026-09-11",
    readTime: "7分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20entrance%20with%20warm%20gold%20lighting%20and%20velvet%20ropes%2C%20editorial%20photography%2C%20deep%20terracotta%20palette%2C%20no%20people%2C%20soft%20evening%20glow&width=800&height=600&seq=kl-art-04&orientation=landscape",
    tags: ["红毯", "高定", "造型盘点"],
    hot: 5890,
    views: 64000,
    content: [
      "电影之夜的红毯部分照例是造型的集中展示。今年的整体思路比往年更克制，色彩以大地色系与深色调为主。",
      "有艺人选择了结构感很强的高定长裙，肩部设计与建筑线条呼应；也有艺人反其道而行，用一套剪裁利落的简约西装完成亮相。",
      "造型团队在活动结束后陆续放出准备过程的记录，包括试装、改针与配饰挑选。从物料来看，多数造型在正式走红毯前经历了至少两轮调整。",
      "值得关注的是，今年红毯上出现了更多本土设计师品牌的礼服，这一变化在时尚讨论区被多次提及。",
    ],
  },
  {
    id: "2026-0910-05",
    title: "音乐节阵容公布 独立乐队与主流歌手同台成为看点",
    summary:
      "秋季音乐节完整阵容释出，多支独立乐队与流行歌手混编在同一天的舞台安排里，乐迷讨论热度持续走高。",
    channelSlug: "music",
    channelName: "音乐风云频道",
    author: "看料社音乐组",
    date: "2026-09-10",
    readTime: "5分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20stage%20at%20sunset%20with%20warm%20amber%20lights%20and%20crowd%20silhouettes%2C%20editorial%20photography%2C%20terracotta%20and%20cream%20palette%2C%20cinematic%20tone&width=800&height=600&seq=kl-art-05&orientation=landscape",
    tags: ["音乐节", "阵容公布", "独立乐队"],
    hot: 5120,
    views: 58000,
    content: [
      "秋季音乐节公布了完整的三日阵容，最受关注的安排是把多支独立乐队与流行歌手放在同一天的舞台。",
      "主办方在说明中提到，这种混编是为了让不同听众群有更多交叉体验的机会。从票务反馈看，首日与次日的门票在开售后不久就进入紧张状态。",
      "乐队方面也陆续确认了演出时长，部分场次会带来从未公开的新歌首唱。具体歌单目前仍未公布。",
      "音乐节将于下月开场，场地方已经完成主舞台的搭建方案公示。",
    ],
  },
  {
    id: "2026-0910-06",
    title: "剧组幕后特辑上线 摄影指导谈夜间戏打光思路",
    summary:
      "正在热播的剧集放出幕后特辑，摄影指导在访谈里拆解了夜间戏的打光逻辑，这段内容被从业者反复转发。",
    channelSlug: "behind",
    channelName: "幕后揭秘版块",
    author: "看料社幕后组",
    date: "2026-09-10",
    readTime: "8分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Film%20camera%20equipment%20and%20lighting%20rig%20on%20a%20night%20set%2C%20editorial%20photography%2C%20warm%20amber%20highlights%20against%20dark%20brown%20background%2C%20no%20people%2C%20cinematic%20mood&width=800&height=600&seq=kl-art-06&orientation=landscape",
    tags: ["幕后特辑", "摄影指导", "灯光"],
    hot: 4380,
    views: 47000,
    content: [
      "热播剧集本周上线了一支幕后特辑，全长约十二分钟，主要围绕夜间戏的拍摄展开。",
      "摄影指导在访谈中解释，为了避免夜景过曝，团队把主要光源压得很低，只在人物一侧保留轮廓光，其余部分交给环境反射。",
      "特辑还展示了剧组自制的柔光装置，用常见的反光材料配合轨道灯完成。这段内容在从业者社群中获得不少讨论。",
      "制片方表示，后续还会放出剪辑与美术方向的幕后内容，形成完整系列。",
    ],
  },
  {
    id: "2026-0909-07",
    title: "社交平台热搜榜单周变化 话题生命周期呈现缩短趋势",
    summary:
      "对一周热搜数据的整理显示，话题从进入到退出的平均时长比上季度有所缩短，内容消费节奏正在变快。",
    channelSlug: "trending",
    channelName: "全网热搜频道",
    author: "看料社数据组",
    date: "2026-09-09",
    readTime: "6分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20data%20visualization%20with%20flowing%20amber%20and%20terracotta%20lines%20on%20cream%20background%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=600&seq=kl-art-07&orientation=landscape",
    tags: ["热搜榜", "数据整理", "话题周期"],
    hot: 4720,
    views: 51000,
    content: [
      "我们整理了近一周主要平台的热搜榜变化，统计了话题进入榜单到退出榜单的时间跨度。",
      "结果显示，话题的平均在线时长比上一季度缩短了大约百分之十二。娱乐类话题的变化最明显，不少话题在半天内就完成了升温与回落。",
      "从内容形态看，短平快的合集与现场片段传播效率更高，长图文整理的分享率相对稳定但增速放缓。",
      "数据仅统计公开榜单的可见变化，不涉及任何非公开信息。",
    ],
  },
  {
    id: "2026-0909-08",
    title: "直播行业内容调整 多位创作者转向长视频叙事",
    summary:
      "近期多位内容创作者减少了高频直播，把精力放在制作周期更长的纪录式视频上，这一变化在创作者社群被广泛讨论。",
    channelSlug: "influencer",
    channelName: "网红追踪版块",
    author: "看料社创作者组",
    date: "2026-09-09",
    readTime: "5分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Content%20creator%20desk%20setup%20with%20camera%20and%20warm%20desk%20lamp%2C%20editorial%20photography%2C%20terracotta%20and%20cream%20palette%2C%20no%20people%2C%20cozy%20atmosphere&width=800&height=600&seq=kl-art-08&orientation=landscape",
    tags: ["创作者", "长视频", "内容转型"],
    hot: 3960,
    views: 43000,
    content: [
      "近一个月，多位长期保持日播节奏的创作者调整了更新计划，把直播频次降低，转而投入制作周期更长的叙事类视频。",
      "从公开说明看，调整的主要原因有两个：一是高频直播对状态消耗较大，二是长视频在沉淀观众方面表现更稳。",
      "有创作者在社群中提到，一支十分钟左右的纪录式视频，制作时间可能超过两周，但完播率和讨论深度都更高。",
      "平台方面暂未对这一趋势做出统一回应，但部分平台已经上线了面向中长视频的扶持计划。",
    ],
  },
  {
    id: "2026-0908-09",
    title: "演员公开行程整理 多位艺人确认参与公益活动",
    summary:
      "九月艺人公开行程陆续公布，除常规剧集宣传外，参与公益与青少年艺术教育的安排明显增多。",
    channelSlug: "star",
    channelName: "明星八卦版块",
    author: "看料社编辑部",
    date: "2026-09-08",
    readTime: "5分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20community%20event%20space%20with%20wooden%20benches%20and%20amber%20lighting%2C%20editorial%20photography%2C%20terracotta%20and%20cream%20palette%2C%20no%20people%2C%20calm%20atmosphere&width=800&height=600&seq=kl-art-09&orientation=landscape",
    tags: ["公开行程", "公益活动", "艺术教育"],
    hot: 3240,
    views: 36000,
    content: [
      "根据各工作室公布的行程，九月艺人的公开安排除剧集与综艺宣传外，公益类活动占比有所提升。",
      "多位艺人确认将参与青少年艺术教育相关的短期项目，内容包括线下分享与作品点评，活动规模普遍不大。",
      "有工作室在说明中表示，这类安排会尽量避开宣传期，避免让公益内容与商业活动混在一起。",
      "以上信息均整理自公开渠道发布的行程表，具体安排仍可能调整。",
    ],
  },
  {
    id: "2026-0908-10",
    title: "古装剧美术风格讨论 实景搭建比例成为关注点",
    summary:
      "同档期两部古装剧的美术呈现被放在一起对比，实景搭建与后期合成两种方式各自的特点成为讨论焦点。",
    channelSlug: "drama",
    channelName: "影视爆料频道",
    author: "看料社剧集组",
    date: "2026-09-08",
    readTime: "6分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20wooden%20architecture%20courtyard%20at%20golden%20hour%2C%20editorial%20photography%2C%20warm%20terracotta%20and%20amber%20palette%2C%20no%20people%2C%20cinematic%20tone&width=800&height=600&seq=kl-art-10&orientation=landscape",
    tags: ["古装剧", "美术", "实景搭建"],
    hot: 3680,
    views: 40000,
    content: [
      "同档期的两部古装剧在本周同时更新，观众很自然地把它们的美术风格放在一起比较。",
      "其中一部剧的主要场景来自实景搭建，木结构、砖墙与庭院植被的比例都比较接近真实材料，镜头推近时纹理层次更丰富。",
      "另一部剧则大量使用后期合成，优势在于可以呈现更宏大的空间尺度，但在近景细节上需要更多处理。",
      "两位美术指导在各自采访中都提到，实景与合成并不是替代关系，关键看剧本需要什么样的镜头语言。",
    ],
  },
  {
    id: "2026-0907-11",
    title: "秋季档综艺排播公布 慢节奏生活类节目数量增加",
    summary:
      "各平台秋季档排播表陆续公布，慢节奏的生活观察类节目数量较上一季有所增加，竞技类比例相对下降。",
    channelSlug: "variety",
    channelName: "综艺热点栏目",
    author: "看料社综艺组",
    date: "2026-09-07",
    readTime: "4分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Rustic%20countryside%20kitchen%20with%20warm%20afternoon%20light%20and%20simple%20wooden%20furniture%2C%20editorial%20photography%2C%20terracotta%20and%20cream%20palette%2C%20no%20people%2C%20peaceful%20mood&width=800&height=600&seq=kl-art-11&orientation=landscape",
    tags: ["秋季档", "排播", "生活观察"],
    hot: 2760,
    views: 31000,
    content: [
      "进入九月，各平台陆续公布了秋季档的综艺排播安排。从公开名单看，生活观察与慢节奏旅行类节目的数量有所增加。",
      "竞技类节目的比例相比上一季度下降，但头部竞技综艺仍保留了固定档期。",
      "有制作人分析，慢节奏节目更适合在晚间时段播出，广告与品牌合作的空间也更灵活。",
      "排播表仍可能根据播出效果调整，最终以平台公告为准。",
    ],
  },
  {
    id: "2026-0907-12",
    title: "独立音乐现场观察 小场地演出票房稳步回升",
    summary:
      "多家小型演出场馆公布九月档期，独立音乐现场的上座情况较去年同期有所改善，周边消费也在增长。",
    channelSlug: "music",
    channelName: "音乐风云频道",
    author: "看料社音乐组",
    date: "2026-09-07",
    readTime: "5分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Intimate%20small%20live%20music%20venue%20with%20warm%20amber%20stage%20lights%20and%20wooden%20interior%2C%20editorial%20photography%2C%20terracotta%20palette%2C%20no%20people%2C%20cinematic%20mood&width=800&height=600&seq=kl-art-12&orientation=landscape",
    tags: ["独立音乐", "现场演出", "场馆"],
    hot: 2310,
    views: 27000,
    content: [
      "九月多个城市的独立音乐场地公布了档期，小型演出场次比去年同期有所增加。",
      "场馆方反馈，容量在三百人左右的场地票务表现最稳，很多场次在开票一周内售完。演出周边与唱片销售也同步回升。",
      "有乐队主理人表示，小场地演出的观众互动更直接，也更容易形成长期听众。",
      "值得注意的是，部分场馆开始尝试固定每周的演出日，以培养稳定的观演习惯。",
    ],
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "看料爆料专区里的频道入口是怎么整理的？",
    a: "我们把公开可见的爆料版块、频道与栏目按主题归类，分成明星、影视、综艺、音乐、时尚等方向，每个入口都标注了内容方向与更新频率，方便你按板块直接翻到想看的内容。",
  },
  {
    q: "版块和栏目的区别是什么？",
    a: "版块通常覆盖范围更大，更新更频繁，适合连续浏览；栏目则围绕固定主题或固定节目长期更新，内容更集中。首页与频道大全页都做了类型标签，可以按类型筛选。",
  },
  {
    q: "内容多久更新一次？",
    a: "热搜与高频版块基本保持实时跟进，影视、幕后等更新相对稳定，一般每天至少整理一次。每个频道入口上都会显示最近更新时间。",
  },
  {
    q: "可以在站内搜索具体的瓜点吗？",
    a: "可以。首页顶部的搜索框支持按关键词在频道与爆料之间检索，输入关键词后会同时给出频道入口和相关的爆料条目。",
  },
  {
    q: "站内内容会标注来源吗？",
    a: "站内内容均由编辑整理自公开渠道的公开信息，并在文末标注整理时间。对于尚未证实的说法，我们会在正文中明确说明，不会当作结论呈现。",
  },
  {
    q: "如何提交线索或反馈？",
    a: "可以在「联系我们」页面留下你的线索或建议，也可以直接发送邮件到页面上的联系邮箱。我们会安排编辑逐一查看，但不保证每条线索都能成稿。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  quote: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "阿柚",
    role: "追剧爱好者",
    quote: "以前找剧集花絮要在好几个平台来回翻，现在打开频道入口，按板块点进去就能看到整理好的时间线，省事很多。",
  },
  {
    name: "小燃",
    role: "音乐现场常客",
    quote: "音乐风云频道把演出阵容和开票信息放在一起，我基本靠它安排每个月的演出计划，比零散刷消息靠谱。",
  },
  {
    name: "陈一诺",
    role: "内容从业者",
    quote: "幕后揭秘版块的制作向内容很有价值，讲灯光、剪辑这些细节的时候，能看出编辑是真的在做功课。",
  },
  {
    name: "桃子汽水",
    role: "综艺观众",
    quote: "热搜频道会把话题从升温到回落的过程记下来，回头看某期节目的讨论走向特别清楚，很有意思。",
  },
];

export const stats = [
  { label: "收录频道入口", value: "8", suffix: "个" },
  { label: "整理爆料条目", value: "6,500", suffix: "条" },
  { label: "日均更新", value: "120", suffix: "条" },
  { label: "覆盖内容方向", value: "12", suffix: "类" },
];

export const hotSearches = [
  "音乐盛典后台",
  "新剧杀青",
  "综艺录制现场",
  "红毯造型",
  "音乐节阵容",
  "热搜榜变化",
];